import type { ReactNode } from "react";

export interface DraggableCellContentProps {
	/** The column ID for sortable context */
	columnId: string;
	/** Children to render inside the cell */
	children: ReactNode;
	/** Additional className for the wrapper */
	className?: string;
	/** Whether this column is being dragged */
	isDragging?: boolean;
}

/**
 * DraggableCellContent wraps table cell content to indicate
 * which column is being dragged.
 * Works inside React Aria's Cell component.
 */
export function DraggableCellContent({
	children,
	className,
	isDragging,
}: DraggableCellContentProps) {
	return (
		<div
			className={className}
			style={{
				opacity: isDragging ? 0.5 : 1,
				transition: "none",
			}}
		>
			{children}
		</div>
	);
}
